import React, { FC } from 'react';
import { TitleRow } from 'components/TitleRow';
import styles from './UsersList.module.scss';
import { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { CustomerUserItem } from 'ui/CustomerUserItem';
import { UserType } from 'redux/Api/usersApi/type';

interface UsersListTypes {
  usersList: UserType[];
  intersectionRef?: UseInfiniteScrollHookRefCallback;
}

export const UsersList: FC<UsersListTypes> = ({ usersList, intersectionRef }) => {
  const dataTitle = [
    'ID',
    'Фамилия',
    'Имя',
    'Отчество',
    'Роль',
    'Заказчик',
    'E-mail подтвержден',
    'Оферта подписана',
    'Уведомление по заказам',
    'Телефон',
    'E-mail',
    'Дата создания',
    'Дата изменения',
    '2FA',
  ];

  return (
    <div className={styles.root}>
      <TitleRow data={dataTitle} title={'usersWorkSupport'} />
      {usersList ? (
        usersList.map((elem: UserType, index: number) => {
          const triggerIndex = Math.max(0, usersList.length - 15);
          const shouldAttachRef = index === triggerIndex;

          return (
            <div key={elem.id} ref={shouldAttachRef ? intersectionRef : undefined}>
              <CustomerUserItem user={elem} />
            </div>
          );
        })
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
